import React from 'react';
import { CSSTransition } from 'react-transition-group';
import './styles.css';
import {ANIMATION_TIMEOUT_APPEAR} from '../../constants/animation';

const HorizontalLoader = props => {
  return (
    <CSSTransition
      in={true}
      appear={true}
      timeout={ANIMATION_TIMEOUT_APPEAR}
      classNames="fade"
    >
      <div className="horizontal-loader" style={props.loaderStyles}>
        <div className="horizontal-loader__dot" />
        <div className="horizontal-loader__dot" />
        <div className="horizontal-loader__dot" />
        <div className="horizontal-loader__dot" />
      </div>
    </CSSTransition>
  );
};

export default HorizontalLoader;
